import { Router } from '@angular/router';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Logger } from 'angular2-logger/core';

import { SharedService } from '../../../shared/shared.service';
import { UserService } from '../user.service';
import { environment } from '../../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ScheduleService } from '../../schedule/schedule.service';

// import * as $ from 'jquery';
//Jquery
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
  providers: [ScheduleService]
})

export class UserListComponent implements OnInit, AfterViewInit {
  //public load: boolean;
  public list: any;
  //public m_load: boolean;
  public details: any;
  public pag_size: number;
  public pag_number: number;
  public total_items: number;
  public id_user: string;
  public del_user: string;
  private Math = Math;
  public itemQuantity = [];
  public on_button = false;
  public schedule: any = {};
  public text_delete: any;
  public text_reset: any;
  public total_agentes : any;
  public total_admin : any;
  public total_super_user : any;
  public total_supervisor : any;
  public dataExcel_3 : any;

  public day_helper = { 1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday', 7: 'sunday' };
  @ViewChild('contacts_pag') contacts_pag: ElementRef;
  @ViewChild('contacts_num') contacts_num: ElementRef;

  constructor(
    private _userService: UserService,
    private _sharedService: SharedService,
    private _router: Router,
    public toastr: ToastsManager,
    private logger: Logger,
    private spinner: NgxSpinnerService,
    private _scheduleService: ScheduleService) {

    this.schedule.monday = [];
    this.schedule.tuesday = [];
    this.schedule.wednesday = [];
    this.schedule.thursday = [];
    this.schedule.friday = [];
    this.schedule.saturday = [];
    this.schedule.sunday = [];

    //this.load = false;
    //this.m_load = false;
    this.pag_size = 10;
    this.pag_number = 1;
  }

  ngAfterViewInit() {

    $(this.contacts_pag.nativeElement).on('change', (e) => {
      this.pag_size = e.target.value;
      this.pag_number = 1;
      this.updatePage();
    });

    $(this.contacts_num.nativeElement).on('change', (e) => {
      this.pag_number = e.target.value;
      this.updatePage();
    });

  }

  ngOnInit() {
    this.updatePage();
  }

  updatePage() {

    //this.load = true;
    this.spinner.show();
    this.text_delete = false;
    this.text_reset = false;

    this.dataExcel_3 = [];

    let data = {
      auth_token: this._sharedService.getCookie("auth_token"),
      limit: this.pag_size, // quantity of items
      page: this.pag_number  // page
    };

    this._userService.getlist(data).subscribe(
      data => {
        //this.load = false;
        this.spinner.hide();
        if (data.status) { //success
          this.list = data.data.data.data; //data list
          this.total_items = data.data.data.total;
          this.itemQuantity = Array(data.data.data.last_page).fill(0).map((x, i) => i + 1);
          this.total_agentes = data.data.countAgent;
          this.total_admin = data.data.countAdmin;
          this.total_super_user = data.data.countSuperAgente;
          this.total_supervisor = data.data.countSupervisor;
            console.log(data.data.data.data);
          for (let i in this.list) {
            let rol = '';
            if (this.list[i].role_id == '3') {
                rol = 'Agente';
            } else if (this.list[i].role_id == '2') {
                rol = 'Usuario';
            } else if (this.list[i].role_id == '1') {
                rol = 'Administrador';
            } else if (this.list[i].role_id == '5') {
                rol = 'Supervisor';
            } else if (this.list[i].role_id == '6') {
                rol = 'Super usuario';
            }

            let tempExcel = [];
            tempExcel['Nombre'] = this.list[i].firstname + this.list[i].lastname;
            tempExcel['Correo'] = this.list[i].email;
            tempExcel['Estado'] = this.list[i].suspended == '0' ? 'Habilitado' : 'Inhabilitado';
            tempExcel['Rol'] = rol;
            tempExcel['Creado'] = this.list[i].created_at;
            tempExcel['Actualizado'] = this.list[i].updated_at;

            this.dataExcel_3.push(tempExcel);
        }


        } else { // API error
          this.toastr.error(data.message, 'Error');
        }

      },
      error => { //server error
        //this.load = false;
        this.spinner.hide();
        this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
        this.logger.log(error);
      }
    );

  }

  modalReset(id) {

    if (id) {

      //this.load = true; // loading screen
      this.spinner.show();
      this.text_reset = true;

      let registro = this.list.find(item => item.id === id);

      let data = {
          email: registro ? registro.email : null // Evita errores si el ID no existe
      };
     
      this._userService.resetpass(data).subscribe(
        data => {
          if (data.status) {
            this.toastr.success('Un correo electrónico ha sido enviado con tu nueva contraseña', '¡Éxito!');

          } else {
            this.toastr.error(data.message);
          }

          //this.load = false;
          this.spinner.hide();
          this.text_reset = false;
        },
        error => {
          this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
          //this.load = false;
          this.spinner.hide();
          this.logger.log(error);
        }
      );

    }
  }

    exportAsXLSX(): void {
        this._userService.exportAsExcelFile(this.dataExcel_3, 'reporte');
    }

  modalDelete(id) {

    if (id) {

      //this.load = true; // loading screen
      this.spinner.show();
      this.text_delete = true;

      let data = {
        auth_token: this._sharedService.getCookie('auth_token'), // get cookie
        id: id
      };

      this._userService.deleteuser(data).subscribe(
        data => {
          if (data.status) {

              if (data.message == 'user.deletedFailRooms') {
                this.toastr.error("El usuario tiene conversaciones asociadas, no puede ser eliminado", 'Error');
              } else if(data.message == 'user.deletedFail'){
                this.toastr.error("Ocurrió un error al eliminar el usuario ", 'Error');
              } else {
                this.toastr.success('El usuario ha sido eliminado', '¡Éxito!');

                //Elimino el horario asociado
                let paramDelete = {
                  auth_token: this._sharedService.getCookie('auth_token'),
                  user_id: id
                }
                this._userService.deleteLoteUserSchedule(paramDelete).subscribe(
                  responDelete => {
                    this.logger.log("User Schedule eliminado correctamente");
                  }, errorDelete => {
                    this.logger.log("Error eliminando el user schedule", errorDelete);
                  }
                );
    
                this.updatePage();
              }
          } else {
            this.toastr.error(data.message, 'Error');
          }

          //this.load = false;
          this.spinner.hide();
          this.text_delete = false;
        },
        error => {
          this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
          //this.load = false;
          this.spinner.hide();
          this.logger.log(error);
        }
      );
    }

  }

  onEdit(id: number) {
    this._router.navigate(['./admin/users/edit', id]);
  }

  onDetails(id: number) {

    if (!this.on_button) {
      $('#Details').modal('toggle'); // open modal

      //this.m_load = true;
      this.spinner.show();
      this.details = this.list[id]; // user


      let param = {
        auth_token: this._sharedService.getCookie('auth_token'), // get cookie
        id_agent: this.details.id,
        type: 1 //solo el horario regular
      }
      this._scheduleService.getSchedulesByIdAgentAndType(param).subscribe(
        resp => {
          if (resp.status && resp.data.length > 0) {
            let data = {
              auth_token: this._sharedService.getCookie('auth_token'),
              id: resp.data[0].id
            }

            this._userService.getSchedule(data).subscribe(
              data => {
                if (data.status) {
                  this.logger.log(data.data);
                  this.logger.log('schedule data received');
                  this.schedule.name = data.data.name

                  for (let i = 0; i < data.data.schedules.length; i++) {
                    let aux_day = this.day_helper[data.data.schedules[i].day_week];
                    this.schedule[aux_day] = data.data.schedules[i].shift;
                  }

                } else {
                  //data.message
                  this.toastr.warning('El registro no fue encontrado, por favor intente de nuevo', 'Error');
                }
      
                this.spinner.hide();
              },
              error => {
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                //this.m_load = false;
                this.spinner.hide();
                this.logger.log(error);
              }
            );
          } else {
            this.toastr.info("No se encontró horario regular asociado al usuario", 'Info');
            this.spinner.hide();
          }
        }, error => {
          this.spinner.hide();
          this.toastr.error(error.message, 'Error');
        }
      );
    }
    this.on_button = false;
  }

  onResetPass(id: string) {

    $('#PasswordReset').modal('toggle');

    this.id_user = id;

    this.on_button = true;

  }

  onDelete(id: string) {

    $('#DeleteUser').modal('toggle');

    this.on_button = true;

    this.del_user = id;
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/user/user-list/user-list.component.ts